import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { Router, NavigationEnd } from "@angular/router";

@Injectable()
export class TransportHistoryService {
  private base_url = `${environment.API_URL}/plannings`;
  //private base_url = this.router.url;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(
    private http: HttpClient,
    private toast: ToastService,
    private router: Router
  ) {}

  getHistory(departure_id: number, arrival_id: number, client_id: number) {
    return this.http
      .post(
        this.base_url + "/history",
        {
          departure_id: departure_id,
          arrival_id: arrival_id,
          client_id: client_id,
        },
        { headers: this.headers }
      )
      .map((res: any[]) => res);
  }

  toPlanning(planning_data) {
    return this.http
      .post(this.base_url + "/from_demand", planning_data, {
        headers: this.headers,
      })
      .map((data) => {
        //console.log(data);
        this.toast.success("Transport ajouté au planning.", false, "Planning");
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/transport-history.service.ts